import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function PricingCTA() {
  return <section id="comprar" className="py-24 bg-sage/10 relative" data-id="element-201">
      <div className="max-w-4xl mx-auto px-6" data-id="element-202">
        <FadeIn className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-sage/20 relative overflow-hidden" data-id="element-203">
          <div className="absolute top-0 right-0 w-64 h-64 bg-sage/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-204"></div>

          <div className="relative z-10 text-center mb-10" data-id="element-205">
            <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-4" data-id="element-206">
              Comienza a liberar tu espalda
            </h2>
            <p className="text-lg text-warm-dark/70" data-id="element-207">
              Descarga inmediata. Lee a tu ritmo, desde cualquier dispositivo.
            </p>
          </div>

          {/* Price */}
          <div className="text-center mb-10" data-id="element-208">
            <span className="text-xl text-warm-dark/40 line-through font-heading" data-id="element-209">
              $27 USD
            </span>
            <span className="text-5xl font-heading font-bold text-warm-dark block mt-1" data-id="element-210">
              $14.99 USD
            </span>
            <p className="text-sm text-warm-dark/50 mt-2 uppercase tracking-wider" data-id="element-211">
              Pago único
            </p>
          </div>

          {/* Primary CTA - directly below price */}
          <div className="text-center space-y-4 mb-12" data-id="element-212">
            <Button href="https://pausaviva.com/cart/47287315398805:1" onClick={() => trackAddToCart({
            content_name: 'Espalda Libre Ebook',
            content_type: 'product',
            value: 14.99,
            currency: 'USD'
          })} className="w-full md:w-auto px-12 py-5 text-xl shadow-lg shadow-sage/30" data-id="element-213">
              Comprar Ebook Ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-warm-dark/60" data-id="element-214">
              <ShieldCheck className="w-4 h-4" data-id="element-215" />
              <span data-id="element-216">Pago 100% seguro. Acceso inmediato.</span>
            </div>
          </div>

          {/* Bonuses image */}
          <div className="rounded-2xl overflow-hidden border border-warm-accent/10" data-id="element-217">
            <img src="https://cdn.magicpatterns.com/uploads/qYitQwhBwaM3cgYgNdnHJC/6472933B-0F6F-44B6-924B-48EACE2B50C0.png" alt="También recibirás Hoy: 4 bonos exclusivos incluidos — Guía de alimentación antiinflamatoria, Rutina diaria de ejercicios, Guía emocional para los días difíciles y 3 meditaciones guiadas" className="w-full h-auto object-contain" data-id="element-218" />
          </div>
        </FadeIn>
      </div>
    </section>;
}